<template>
    <div class="search-menu" :class="{ 'is-open': isSearch }" ref="searchMenu">
        <div class="search-container" v-show="isSearch" @click="handleContentClick">
            <div class="search-header">
                <form class="search-form" @submit.prevent="handleSubmit" ref="searchFormTop">
                    <a class="cursor-pointer" @click="clearInput"><i class="icon-close"></i></a>
                    <input
                        type="text"
                        name="s"
                        ref="searchInput"
                        v-model="searchQuery"
                        @input="items.length = []"
                    >
                    <a class="cursor-pointer" @click="handleSubmit"><i class="icon-search"></i></a>
                </form>
            </div>
            <div class="search-result" id="searchResult">
                <div class="search-result-card" v-if="items.length">
                    <div class="search-query">Search results for: <strong>"{{ this.searchQuery.trim() }}"</strong></div>
                    <div class="search-items">
                        <template v-for="item in items">
                            <a
                                class="item"
                                :href="item.product_url"
                                :title="item.product_title"
                            >
                                <div class="thumbnail" v-if="item.thumbnail && item.thumbnail?.thumbnail">
                                    <img :src="item.thumbnail.thumbnail" loading="lazy">
                                </div>
                                <div class="thumbnail" v-else>
                                    <img :src="`${images_url}/empty/thumbnail_small.png`" loading="lazy">
                                </div>
                                <div class="info">
                                    <div class="product-title">
                                        {{
                                            item.product_title.length > 90
                                            ? item.product_title.slice(0, 90) + '...'
                                            : item.product_title
                                        }}
                                    </div>
                                </div>
                                <div class="prices">
                                    <div class="sale_price">
                                        {{ NumberFormat.format( item.sale_price / 100 ) }}
                                    </div>
                                    <div class="price" v-if="1 === 0 && item.sale_price < item.price ">
                                        {{ NumberFormat.format( item.price / 100 ) }}
                                    </div>
                                </div>
                            </a>
                        </template>
                    </div>
                </div>
                <div class="search-result-card" v-if="items.length === 0 && searchMessage.length">
                    <div class="text-center pt-4 pb-4">
                        {{ searchMessage }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const SEARCH = '.searchMenu'; // кнопка search

    import { defineComponent } from 'vue'
    export default defineComponent({
        name: "search",
        data() {
            return {
                images_url: '/templates/Goya/assets/images',
                stats: window.stats || [],
                NumberFormat: {},

                isSearch: false,
                isLoading: false,

                searchMenu: false,
                searchResult: null,

                searchQuery: '',
                items: [],
                searchMessage: ''
            }
        },
        created() {
            this.NumberFormat = new Intl.NumberFormat('en-US', {style: 'currency', currency: this.stats.currency || 'USD'});
        },
        mounted() {
            this.searchMenu = document.querySelectorAll( SEARCH )
            if( this.searchMenu ) {
                this.searchMenu.forEach((e) => e.addEventListener('click', async () => {
                    await this.addFormListener()
                }))
            }
            this.searchResult = document.getElementById('searchResult');
        },
        beforeUnmount() {
            this.removeClickListener();

            if( this.searchMenu ) {
                this.searchMenu.forEach((e) => e.removeEventListener( 'click', this.openForm ))
            }
        },
        computed: {
            domain() {
                return window.location.hostname.replace('www', '')
            },
        },
        methods: {
            /**
             * Поиск
             */
            async addFormListener() {
                try {
                    // Ждем, пока меню полностью откроется
                    await this.openForm()
                    document.addEventListener('click', this.handleClickOutside, { passive: false })
                } catch (error) {
                    console.error('Error when try to open form:', error)
                }
            },
            openForm() {
                return new Promise((resolve) => {
                    // открываем форму search
                    this.isSearch = true;

                    // фокус на input поле
                    this.$nextTick(() => {
                        this.$refs.searchInput.focus();
                    });

                    // добавить анимацию или другие асинхронные операции?
                    setTimeout(() => {
                        resolve()
                    }, 300)
                })
            },
            closeForm() {
                this.isSearch = false;
                this.removeClickListener()
            },
            async handleSubmit() {

                if( this.isLoading )
                    return;

                this.searchMessage = '';
                this.isLoading = true;

                if( this.searchQuery.trim().length ) {
                    try {
                        const response = await this.$http.post('/product/list', JSON.stringify({
                            search: this.searchQuery,
                            page_size: 10
                        }))
                        let data = response.data.data;

                        this.items = data.items || []
                        if( this.items.length === 0 )
                            this.searchMessage = 'No results yet';
                    } catch ( err ) {
                        console.error('error: ', err)
                    } finally {
                        this.isLoading = false;
                    }
                } else {
                    this.isLoading = false;
                }
            },
            clearInput() {
                this.searchQuery = '';
                this.items.length = 0;
                this.$nextTick(() => {
                    this.$refs.searchInput.focus();
                });
            },

            // Удаление слушателя клика
            removeClickListener() {
                document.removeEventListener( 'click', this.handleClickOutside )
            },

            // Обработка клика вне компонента
            handleClickOutside(event ) {
                const c1 = document.querySelector('.search-header')
                if(
                    this.$refs.searchMenu &&
                    this.isSearch &&
                    ! c1.contains( event.target ) &&
                    ! this.searchResult.contains( event.target )
                ) {
                    this.closeForm()
                }
            },

            // Обработка клика внутри контента
            handleContentClick( event ) {
                this.handleClickOutside( event );
                event.stopPropagation() // Останавливаем распространение события
            },
        }
    })
</script>

<style scoped>

</style>